// FavList.jsx
import React, { Component } from "react";
import { ProductSingleProductView } from "./ProductSingleProductView";
import { FiRefreshCcw } from "react-icons/fi";
import { BsStar } from "react-icons/bs";
import {
  Button,
  Table,
  Tooltip,
  OverlayTrigger,
  Card,
  Form,
  Stack,
} from "react-bootstrap";
import CartContext from "./CartContext";
import { FaHome } from "react-icons/fa";

export default class FavList extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      value: "",
      show: true,
      showSingleView: false,
      ProdSingleView: null,
      showSku: false,
      productView: "list",
    };
  }

  handleProductView = (event) => {
    this.setState({ productView: event.target.value });
    localStorage.setItem("productView", event.target.value);
  };

  forceUpdate = () => {
    this.setState({ value: 0 });
    return () => this.setState({ value: this.state.value + 1 });
  };

  OpenSingleView = (prod) =>
    this.setState({ ProdSingleView: prod, showSingleView: true });

  editModalClose = () => {
    this.setState({ showSingleView: false }, () =>
      this.context.forceUpdateCartView()
    );
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    const productView = localStorage.getItem("productView") || "list";
    this.setState({ productView });

    this.context.UpdateOrderStatus("");

    const showSku = localStorage.getItem("showSku") === "true";
    this.setState({ showSku });

    document.addEventListener("keydown", this.handleKeydownFav);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeydownFav);
  }

  handleKeydownFav = (e) => {
    // ESC key
    if (e.keyCode === 27) {
      this.context.SetHideFav(true);
    }
    // Ctrl+F4
    if (e.ctrlKey && e.keyCode === 115) {
      // F4
      e.preventDefault();
      this.context.SetHideFav(true);
    }
  };

  getProduct = (prodId) =>
    this.context.prodsAll.find((p) => p.id === prodId) || null;

  addToCartSubmit = (prod) => {
    if (this.context.modeOfSale === "TableOrder") {
      this.props.AddRestaurantTableOrderItem({ prod, qty: 1 });
    } else {
      this.context.addToPOSCart(this.context.selectedPOS, { prod, qty: 1 });
    }
    this.context.forceUpdateCartView();
  };

  handleInputChange = (e, wishListProductId) => {
    const { name, value } = e.target;
    if (name === "seqNo") {
      const updated = { ...wishListProductId, seqNo: value };
      this.context.UpdateWishList(updated);
      this.forceUpdate();
    }
  };

  renderSkuList() {
    return (
      <div className="p-2">
        {this.context.wishListProductIds.map((wish) => {
          const product = this.getProduct(wish.prodId);
          if (!product || !product.sku) return null;

          return product.productVariantType === 2 ? (
            <Button
              key={product.id}
              className="m-1"
              style={{
                backgroundColor: this.context.theme.mainNavBarBackgroundColor,
                color: this.context.theme.mainNavBarTextColor,
              }}
              onClick={() => this.OpenSingleView(product)}
            >
              {product.sku}
            </Button>
          ) : (
            <Button
              key={product.id}
              className="m-1"
              onClick={() => this.addToCartSubmit(product)}
            >
              {product.sku}
            </Button>
          );
        })}
      </div>
    );
  }

  renderGridView() {
    return (
      <div className="row justify-content-around py-2">
        {this.context.wishListProductIds.map((wish) => {
          const product = this.getProduct(wish.prodId);
          if (!product) return null;

          const sellingPrice = Math.round(
            product.mrp - (product.mrp * product.discount) / 100
          );

          return (
            <Card
              key={product.id}
              style={{ width: "3.5cm" }}
              className="border-0"
            >
              {product.imgFileName && (
                <Card.Img
                  variant="top"
                  src={`${this.context.store.storageBlobUrl}${this.context.store.storageBlobContainerName}/images/${product.imgFileName}${this.context.store.storageSasToken}`}
                  alt={product.name}
                  onClick={() => this.OpenSingleView(product)}
                  style={{ cursor: "pointer", width: "100%" }}
                />
              )}
              <Card.Body className="p-2 m-0">
                <Card.Text className="text-center p-0 m-0">
                  {product.name}
                  <br />
                  <h5>
                    <b>
                      {sellingPrice.toLocaleString(
                        this.context.storeSettings.defaultLocale,
                        {
                          style: "currency",
                          currency: this.context.storeSettings.defaultCurrency,
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 1,
                        }
                      )}
                    </b>
                    {product.discount > 0 && (
                      <>
                        <br />
                        <small style={{ fontSize: "10px" }}>
                          {product.discount}% OFF
                        </small>
                      </>
                    )}
                  </h5>
                  {product.productVariantType === 2 ? (
                    <Button
                      className="w-100"
                      style={{ backgroundColor: "cyan", color: "black" }}
                      onClick={() => this.OpenSingleView(product)}
                    >
                      View
                    </Button>
                  ) : (
                    <Button
                      className="w-100"
                      style={{ backgroundColor: "cyan", color: "black" }}
                      onClick={() => this.addToCartSubmit(product)}
                    >
                      +ADD
                    </Button>
                  )}
                </Card.Text>
              </Card.Body>
            </Card>
          );
        })}
      </div>
    );
  }

  renderListView() {
    return (
      <Table border className="px-5" responsive="md">
        <thead>
          <tr className="bg-light text-start text-secondary">
            <th></th>
            <th width="45%"></th>
            <th width="20%" className="text-center">
              S.Price
            </th>
            <th width="10%"></th>
            <th width="5%"></th>
            <th width="10%">Seq.No</th>
          </tr>
        </thead>
        <tbody>
          {this.context.wishListProductIds.map((wish) => {
            const product = this.getProduct(wish.prodId);
            if (!product) return null;

            const sellingPrice = Math.round(
              product.mrp - (product.mrp * product.discount) / 100
            );

            return (
              <tr key={product.id}>
                <td width="10%">
                  {product.imgFileName && (
                    <img
                      src={`${this.context.store.storageBlobUrl}${this.context.store.storageBlobContainerName}/images/${product.imgFileName}${this.context.store.storageSasToken}`}
                      alt={product.name}
                      className="cardprodimg-on-cartview mx-auto"
                      style={{ width: ".5cm", cursor: "pointer" }}
                    />
                  )}
                </td>
                <td width="45%">
                  {product.name}
                  <br />
                  <span className="text-primary">SKU: {product.sku}</span>
                </td>
                <td width="20%" className="text-center">
                  <h5>
                    <b>
                      {sellingPrice.toLocaleString(
                        this.context.storeSettings.defaultLocale,
                        {
                          style: "currency",
                          currency: this.context.storeSettings.defaultCurrency,
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 1,
                        }
                      )}
                    </b>
                    {product.discount > 0 && (
                      <>
                        <br />
                        <small style={{ fontSize: "10px" }}>
                          {product.discount}% OFF
                        </small>
                      </>
                    )}
                  </h5>
                </td>
                <td width="10%" className="text-center">
                  {product.productVariantType === 2 ? (
                    <Button
                      className="w-100"
                      style={{
                        backgroundColor:
                          this.context.theme.mainNavBarBackgroundColor,
                        color: this.context.theme.mainNavBarTextColor,
                      }}
                      onClick={() => this.OpenSingleView(product)}
                    >
                      View
                    </Button>
                  ) : (
                    <Button
                      className="w-100"
                      style={{ backgroundColor: "cyan", color: "black" }}
                      onClick={() => this.addToCartSubmit(product)}
                    >
                      +ADD
                    </Button>
                  )}
                </td>
                <td width="5%">
                  <OverlayTrigger overlay={<Tooltip>Delete!</Tooltip>}>
                    <Button
                      variant="outline-danger"
                      onClick={() =>
                        window.confirm("Do you want to Delete?") &&
                        this.context.DeleteProductOnWishList(wish.prodId)
                      }
                    >
                      🗑
                    </Button>
                  </OverlayTrigger>
                </td>
                <td width="10%">
                  <Form.Control
                    type="text"
                    name="seqNo"
                    value={wish.seqNo}
                    className="text-center w-100"
                    onChange={(e) => this.handleInputChange(e, wish)}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }

  render() {
    return (
      <>
        {this.state.showSingleView && (
          <ProductSingleProductView
            show={this.state.showSingleView}
            onHide={this.editModalClose}
            prod={this.state.ProdSingleView}
          />
        )}

        {/* Header Bar */}
        <div
          className="text-center w-100 p-1 m-0"
          style={{
            backgroundColor: this.context.searchBorderColor,
            color: "black",
          }}
        >
          <table className="w-100 p-0 m-0">
            <tbody>
              <tr>
                <td width="20%" className="text-start">
                  <h5>
                    <BsStar /> &nbsp;<b>Favorite List</b>
                  </h5>
                </td>
                <td width="20%">
                  <Button
                    className="border-0 "
                    variant="success"
                    onClick={() =>
                      this.context.SetHideFav(!this.context.hideFav)
                    }
                  >
                    {this.context.hideFav ? (
                      "Show Fav"
                    ) : (
                      <>
                        <FaHome /> BACK <br />
                        <small>(Esc / Ctrl+F4)</small>
                      </>
                    )}
                  </Button>
                </td>
                <td width="20%">
                  <Stack direction="horizontal">
                    <Form.Check
                      checked={this.state.showSku}
                      onChange={() => {
                        const newVal = !this.state.showSku;
                        this.setState({ showSku: newVal });
                        localStorage.setItem("showSku", newVal);
                      }}
                    />
                    &nbsp;SkuList
                  </Stack>
                </td>
                <td width="20%" className="text-end">
                  <Form.Select
                    value={this.state.productView}
                    onChange={this.handleProductView}
                  >
                    <option value="grid">Grid View</option>
                    <option value="list">List View</option>
                  </Form.Select>
                </td>
                <td width="20%" className="text-center">
                  <FiRefreshCcw
                    size={18}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      this.context.SortWishList();
                      this.forceUpdate();
                    }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Wishlist body */}
        <div
          className="fixedTableHightOrderQuque"
          style={{
            minHeight: window.innerHeight - 100 + "px",
            maxHeight: window.innerHeight - 100 + "px",
            fontSize: "12px",
            fontWeight: "bold",
          }}
        >
          {this.state.showSku && this.renderSkuList()}
          {this.state.productView === "grid"
            ? this.renderGridView()
            : this.renderListView()}
        </div>
      </>
    );
  }
}
